import { render, staticRenderFns } from "./high-discount.vue?vue&type=template&id=f29f9e96&scoped=true"
import script from "./high-discount.vue?vue&type=script&lang=js"
export * from "./high-discount.vue?vue&type=script&lang=js"
import style0 from "./high-discount.vue?vue&type=style&index=0&id=f29f9e96&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29f9e96",
  null
  
)

export default component.exports